import { useRouteLoaderData } from '@remix-run/react'
import { useState } from 'react'
import { Button, buttonVariants } from '#app/components/ui/button.js'
import {
	Card,
	CardDescription,
	CardFooter,
	CardHeader,
	CardTitle,
} from '#app/components/ui/card'
import { Icon } from '#app/components/ui/icon.js'

export default function AppSummaryView() {
	const response: any = useRouteLoaderData('routes/app/route')
	const search = response.data.search

	const [showEmpty, setShowEmpty] = useState(false)
	const toggleshowEmpty = () => setShowEmpty(!showEmpty)

	let edges = search.edges

	// filter out empty repos by default
	edges = edges.filter(({ node: repo }: any) => {
		if (showEmpty) return true
		return repo.pullRequests.totalCount > 0
	})

	// sort by # open PRS
	// (assumes complete search result & no pagination)
	edges = edges.sort(({ node: repo1 }: any, { node: repo2 }: any) => {
		return repo2.pullRequests.totalCount - repo1.pullRequests.totalCount
	})

	return (
		<div className="flex flex-col items-center">
			<div className="flex flex-wrap justify-center gap-4">
				{edges.map(({ node: repository }: any) => {
					return (
						<Card key={repository.id} className="w-[240px]">
							<CardHeader>
								<CardTitle className="text-center text-h3">
									{repository.pullRequests.totalCount}
								</CardTitle>
								<CardDescription className="h-8 break-words">
									{repository.nameWithOwner}
								</CardDescription>
							</CardHeader>
							<CardFooter className="justify-end">
								<a
									href={repository.url + '/pulls'}
									target="_blank"
									rel="noreferrer"
									className={buttonVariants({ variant: 'outline' })}
								>
									<span className="mr-1">View Repo</span>
									<Icon name="external-link"></Icon>
								</a>
							</CardFooter>
						</Card>
					)
				})}
			</div>
			<p className="mt-4 text-sm text-muted-foreground">
				Repos with no active pull requests are hidden by default.{' '}
				<Button onClick={toggleshowEmpty} variant="link" size="sm">
					{showEmpty ? 'Hide Empty' : 'Show All'}
				</Button>
			</p>
		</div>
	)
}
